import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { LoginToken } from './../../../interfaces/auth';
import { PetService } from './../../../services/pet.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required])
  });
  isLoading = false;
  error = '';

  constructor(
    private petService: PetService,
    private router: Router,
    private formBuilder: FormBuilder,
  ) {
    this.createForm();
  }

  ngOnInit() {
    if (localStorage.getItem('access_token')) {
      this.router.navigate(['home']);
    }
  }

  private createForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', Validators.required],
    });
  }

  login() {
    console.log(
      this.loginForm.controls.username.value,
      this.loginForm.controls.password.value);
    console.log("DONE 1");
    this.isLoading = true;
    this.error = '';

    this.petService
      .login(
        this.loginForm.controls.username.value || '',
        this.loginForm.controls.password.value || ''
      )
      .subscribe({
        next: (response) => {
          console.log(`login response: ${JSON.stringify(response)}`);
          this.isLoading = false;
          if (response.error) {
            this.error = response.error_description;
          } else if (response.access_token) {
            console.log(`login response.access_token: ${response.access_token}`);
            this.saveResponseToStorage(response);
            this.petService.loadUserPermissions().subscribe({
              next: (permissionResponse) => {
                var permissions = permissionResponse.permissions;
                console.log(`login, loadUserPermissions, permissionResponse: ${JSON.stringify(permissions)}`);
                localStorage.setItem("permissions", JSON.stringify(permissions));
                this.petService.setPermissions(permissions);
                this.router.navigate(['home']);
              },
              error: (error) => {
                console.log(`login, loadUserPermissions, error: ${JSON.stringify(error)}`);
              }
            });

            // Load current user details
            this.petService.getCurrentUserDetail().subscribe({
              next: (userResponse) => {
                var currentUser = userResponse;
                console.log(`login, getCurrentUser, userResponse: ${JSON.stringify(userResponse)}`);
                this.petService.setCurrentUser(currentUser);
                this.router.navigate(['home']);
              },
              error: (error) => {
                console.log(`login, getCurrentUser, error: ${JSON.stringify(error)}`);
              }
            });

          } else {
            this.error = response.message;
          }
        },
        error: (error) => {
          this.error = error.error.error_description;
          this.isLoading = false;
          this.loginForm.markAsPristine();
          if (!this.error) {
            this.error =
              'Something went wrong. Try again or contact the System Administrator';
          }
        }
      });
  }

  saveResponseToStorage(response: LoginToken) {
    this.loginForm.markAsPristine();
    const now = new Date();
    const e = now.getTime() + (response.expires_in - 600) * 500;
    localStorage.setItem('token_expiration', e.toString());
    localStorage.setItem('access_token', response.access_token);
    localStorage.setItem('refresh_token', response.refresh_token);
    //this.router.navigate(['home']);
  }

}
